import React from "react";
import CharitiesPage from "@pages/Charities/CharitiesPage";
import CharityEditorPage from "@pages/Charities/CharityEditorPage";
import ProtectedRoute from "@components/routes/ProtectedRoute";

export default [
    {
        path: "charities",
        element: <ProtectedRoute allowedRoles={["root_admin"]} />,
        children: [
            {
                path: "",
                element: <CharitiesPage />,
            },
            {
                path: "editor",
                element: <CharityEditorPage />,
            },
        ],
    },
];
